import { BackgroundCheckPackage } from "@wingspanhq/wingspan-api-sdk";

export const selectorBackgroundChecksActivePackages = (
  packages: BackgroundCheckPackage[]
): BackgroundCheckPackage[] => {
  return packages.filter(p => p.isActive);
};
